import { map } from 'lodash-es'

const scrapingSessionTemplateEditorFormInitialValues = data => {
  if (!data) return {}
  const { id, alias, description, tagGroups } = data

  const tagGroupIds = map(tagGroups, 'id')
  return {
    id,
    alias,
    description,
    tagGroupIds,
  }
}

export default scrapingSessionTemplateEditorFormInitialValues
